<div class="debug-panel">
  <h3> Screen Size Info</h3>
  <p><b>Viewport:</b> {{ width }} x {{ height }}</p>
  <p><b>Zoom:</b>({{ devicePixelRatioPercent }}%)</p>
  <p><b>Tipo de Frame:</b> {{ screenType }}</p>
</div>
